import { all, fork } from 'redux-saga/effects';
import authSaga from '../store/auth/login/store/_saga';
import adminCollegeSaga from '../store/admin/college-management/store/_saga';
import adminDashboardSaga from '../store/admin/dashboard/store/_saga';
import adminSmeApprovalSaga from '../store/admin/sme-approval/store/_saga';
import adminCertificatesSaga from '../store/admin/certificates/store/_saga';
import adminAnalyticsSaga from '../store/admin/analytics/store/_saga';
import studentDashboardSaga from '../store/student/dashboard/store/_saga';
import studentCoursesSaga from '../store/student/courses/store/_saga';
import studentQuizzesSaga from '../store/student/quizzes/store/_saga';
import studentAssessmentsSaga from '../store/student/assesments/store/_saga';
import examSaga from '../store/student/exam/store/_saga';
import adminExamSaga from '../store/admin/exam/store/saga';
import studentResultsSaga from '../store/student/results/store/_saga';
import smeDashboardSaga from '../store/sme/dashboard/store/_saga';
import smeContentSaga from '../store/sme/content-upload/store/_saga';
import smeQuizCreationSaga from '../store/sme/quiz-creation/store/_saga';
import smeStudentAnalyticsSaga from '../store/sme/student-analytics/store/_saga';
import smeNotificationsSaga from '../store/sme/notifications/store/_saga';
import collegeDashboardSaga from '../store/college/dashboard/store/_saga';
import collegeStudentSaga from '../store/college/student-management/store/_saga';
import collegeProgressTrackingSaga from '../store/college/progress-tracking/store/_saga';
import collegeCertificatePublishingSaga from '../store/college/certificate-publishing/store/_saga';
import adminCourseSaga from '../store/admin/course-management/store/_saga';
import adminSmeSaga from '../store/admin/sme-management/_saga';
import { adminStudentSaga } from './admin/student-management/store/_saga';
import adminConfigSaga from './admin/admin-config/store/saga'; // Added import for admin config saga
import courseContentSaga from './admin/course-content-management/store/_saga';
import  studentProfileSaga  from './student/profile/store/_saga'; // Added import for student profile saga
import courseSaga from './college/courses-info/store/_saga'; // Added import for college courses info saga
import contentApprovalSaga from './admin/content-approval/store/_saga';
import studentNotificationsSaga from './student/notifications/store/_saga';
import questionBankSaga from './admin/question-bank/store/saga';
import chatbotSaga from './chatbot/_saga';
import chatbotSettingsSaga from './admin/chatbot-settings/_saga';
import studentCertificatesSaga from './admin/student-certificates/_saga';
import customCertificatesSaga from './admin/custom-certificates/store/_saga';
import studentBulkUploadSaga from './admin/student-bulk-upload/store/_saga';
import adminProgressTrackingSaga from './admin/progress-tracking/store/_saga';
export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(adminCollegeSaga),
    fork(adminDashboardSaga),
    fork(adminSmeApprovalSaga),
    fork(adminCertificatesSaga),
    fork(adminAnalyticsSaga),
    fork(adminStudentSaga),
    fork(studentDashboardSaga),
    fork(studentCoursesSaga),
    fork(studentQuizzesSaga),
    fork(studentAssessmentsSaga),
    fork(examSaga),
    fork(adminExamSaga),
    fork(studentResultsSaga),
    fork(smeDashboardSaga),
    fork(smeContentSaga),
    fork(smeQuizCreationSaga),
    fork(smeStudentAnalyticsSaga),
    fork(smeNotificationsSaga),
    fork(collegeDashboardSaga),
    fork(collegeStudentSaga),
    fork(collegeProgressTrackingSaga),
    fork(collegeCertificatePublishingSaga),
    fork(adminSmeSaga), // Added SME management saga
    fork(adminCourseSaga), // Added Course management saga
    fork(adminSmeSaga), // Added SME management saga
    fork(adminConfigSaga), // Added admin configuration saga
    fork(courseContentSaga), // Added course content management saga
    fork(studentProfileSaga), // Added student profile saga
    fork(courseSaga), // Added college courses info saga
    fork(contentApprovalSaga), // Added content approval saga
    fork(studentNotificationsSaga), // Added student notifications saga
    fork(questionBankSaga), // Added question bank saga
    fork(chatbotSaga),
    fork(chatbotSettingsSaga),
    fork(studentCertificatesSaga),
    fork(customCertificatesSaga),
    fork(studentBulkUploadSaga),
    fork(adminProgressTrackingSaga),
  ]);
}